document.addEventListener('DOMContentLoaded', () => {
  const isMobile = () => window.innerWidth < 1024;

  document.querySelectorAll('.capsule-looks').forEach(initSection);

  function initSection(sectionEl) {
    const container = sectionEl.querySelector('.products-look-container');
    const swiperEl = sectionEl.querySelector('.swiper');
    if (!container || !swiperEl) return;

    // The section tag is emitted once per instance, so the asset can run twice
    if (swiperEl.dataset.lookInitialized === 'true') return;
    swiperEl.dataset.lookInitialized = 'true';

    const headingSlider = container.dataset.headingSlider === 'true';
    const paginationEl = sectionEl.querySelector('.swiper-pagination');
    const prevEl = sectionEl.querySelector('.swiper-prev, .swiper-button-prev');
    const nextEl = sectionEl.querySelector('.swiper-next, .swiper-button-next');

    // Mobile progress bar instead of bullets
    function ensureIndicator() {
      if (!paginationEl) return null;
      let indicator = paginationEl.querySelector('.pagination-indicator');

      if (isMobile()) {
        if (!indicator) {
          paginationEl.innerHTML = `<span class="pagination-indicator tw-absolute tw-left-0 tw-top-0 tw-h-full tw-rounded-x10 tw-bg-[#120C0C]"></span>`;
          indicator = paginationEl.querySelector('.pagination-indicator');
        }
        return indicator;
      }

      if (indicator) indicator.remove();
      return null;
    }

    function updateIndicator(swiper) {
      const indicator = ensureIndicator();
      if (!indicator) return;

      const total = swiper.virtualSize || 0;
      const viewport = swiper.size || 0;
      const widthPct = total > 0 ? (viewport / total) * 100 : 100;
      const leftPct = total > viewport ? swiper.progress * (100 - widthPct) : 0;

      indicator.style.width = `${widthPct}%`;
      indicator.style.left = `${leftPct}%`;
    }

    const options = {
      slidesPerView: 'auto',
      watchOverflow: true,

      on: {
        init(swiper) {
          ensureIndicator();
          updateIndicator(swiper);
        },
        progress(swiper) {
          if (isMobile()) updateIndicator(swiper);
        },
        resize(swiper) {
          ensureIndicator();
          updateIndicator(swiper);
        },
        slidesLengthChange(swiper) {
          if (isMobile()) updateIndicator(swiper);
        }
      },
      breakpoints: {
        1024: {
          slidesPerGroupAuto: true,
          navigation: { nextEl, prevEl },
          pagination: {}
        }
      }
    };

    if (headingSlider) {
      options.spaceBetween = 16;
      delete options.breakpoints[1024].navigation;
      delete options.breakpoints[1024].slidesPerGroupAuto;
    } else {
      options.breakpoints[1440] = { enabled: false };
    }

    const swiper = new Swiper(swiperEl, options);

    if (headingSlider) {
      nextEl?.addEventListener('click', () => {
        if (swiper.isEnd) {
          swiper.slideTo(0);
        } else {
          swiper.slideNext();
        }
      });
      prevEl?.addEventListener('click', () => {
        if (swiper.isBeginning) {
          swiper.slideTo(swiper.slides.length - 1);
        } else {
          swiper.slidePrev();
        }
      });
    }

    swiper.on('slideChange', instance => {
      if (typeof calculateScrollPercentage !== 'function') return;

      calculateScrollPercentage(
        instance,
        container.querySelector('.tw-capsule-title')
      );
    });
  }
});
